<template>
  <div class="p-5 text-center bg-dark mb-1">
    <h5 class="text-white">
      ¿Tienes dudas?<br />
      Escríbenos por Whatsapp para ayudarte en minutos.
    </h5>
    <a href="https://api.whatsapp.com/send/?phone=%2B528715060593&text&type=phone_number&app_absent=0" target="_blank" class="btn btn-lg btn-warning text-dark rounded-pill mt-4">
      Contacta a un asesor
    </a>
  </div>
</template>
